// Redux wrapper for the application, used in 
// gatsby-browser.js and gatsby-ssr.js
import React from "react";
import { Provider } from "react-redux";

import createStore from "./src/state/createStore";

export const store = createStore();

export default ({ element }) => {

    return <Provider store={store}>{element}</Provider>
}